import { ExternalLink } from "lucide-react";

interface Props {
  make: string;
  model: string;
  year?: number;
  price?: number;
  listingId?: string;
}

const slug = (s: string) =>
  s.toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function AutoCompareServicesWidget({ make, model, year, price, listingId }: Props) {
  if (!make || !model) return null;
  const m = slug(make);
  const mod = slug(model);
  const utm = `utm_source=roautomarket&utm_medium=listing&utm_campaign=services_widget&utm_content=${listingId || ""}`;
  const params = [
    year ? `year=${year}` : "",
    price ? `price=${price}` : "",
    price ? `currency=EUR` : "",
    `make=${encodeURIComponent(make)}`,
    `model=${encodeURIComponent(model)}`,
    `slug=${m}/${mod}`,
    utm,
  ].filter(Boolean).join("&");

  const links = [
    { href: `https://autocompare.ro/oferte/rca?${params}`, title: "Calculează RCA", desc: `Estimare RCA pentru ${make} ${model}` },
    { href: `https://autocompare.ro/oferte/casco?${params}`, title: "Calculează CASCO", desc: `Prime CASCO pentru ${make} ${model}` },
    { href: `https://autocompare.ro/produs/calculator-cost-total?${params}`, title: "Cost real (TCO)", desc: "Cost total de proprietate pe 5 ani" },
  ];

  return (
    <section className="mb-8 rounded-2xl border border-border bg-muted/30 p-5">
      <h2 className="text-lg font-semibold mb-1">Calculează costurile pentru acest {make} {model}</h2>
      <p className="text-sm text-muted-foreground mb-4">
        Compară oferte de asigurare, finanțare și estimează costul total cu AutoCompare.ro (partener oficial).
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            rel="noopener"
            className="group flex flex-col gap-1 rounded-xl border border-border bg-background p-4 hover:border-destructive hover:shadow-xs transition"
          >
            <span className="flex items-center justify-between font-semibold text-sm">
              {l.title}
              <ExternalLink className="h-3.5 w-3.5 opacity-60 group-hover:opacity-100" />
            </span>
            <span className="text-xs text-muted-foreground">{l.desc}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
